const ACTION_TYPES = {
  UPDATE_VEHICLE_TYPES: "UPDATE_VEHICLE_TYPES",
  UPDATE_VEHICLE_TYPE: "UPDATE_VEHICLE_TYPE",
  UPDATE_IS_LOADING: "UPDATE_IS_LOADING",
  UPDATE_CAR_BRANDS: "UPDATE_CAR_BRANDS",
  UPDATE_CAR_BRAND: "UPDATE_CAR_BRAND",
  UPDATE_CAR_MODELS: "UPDATE_CAR_MODELS",
  UPDATE_CAR_MODEL: "UPDATE_CAR_MODEL",
  UPDATE_CAR_YEARS: "UPDATE_CAR_YEARS",
  UPDATE_CAR_YEAR: "UPDATE_CAR_YEAR",
  UPDATE_CAR_TRIMS: "UPDATE_CAR_TRIMS",
  UPDATE_CAR_TRIM: "UPDATE_CAR_TRIM",
  UPDATE_CAR_ID: "UPDATE_CAR_ID",
  UPDATE_FMV: "UPDATE_FMV",
  UPDATE_INITIAL_FMV: "UPDATE_INITIAL_FMV",
  UPDATE_SUGGESTED_PRICE: "UPDATE_SUGGESTED_PRICE",
  UPDATE_BODY_TYPE: "UPDATE_BODY_TYPE",
  UPDATE_CAR_TYPE: "UPDATE_CAR_TYPE",
  UPDATE_CAR_AGE: "UPDATE_CAR_AGE",
  UPDATE_BANKS: "UPDATE_BANKS",
  UPDATE_BANK: "UPDATE_BANK",
  UPDATE_AON: "UPDATE_AON",
  UPDATE_AON_OPTIONS: "UPDATE_AON_OPTIONS",
  UPDATE_BIPD: "UPDATE_BIPD",
  UPDATE_BIPD_OPTIONS: "UPDATE_BIPD_OPTIONS",
  UPDATE_PA_OPTIONS: "UPDATE_PA_OPTIONS",
  UPDATE_PA: "UPDATE_PA",
  UPDATE_SPECIAL_QUOTE: "UPDATE_SPECIAL_QUOTE",
  UPDATE_EFFECTIVE_DATE: "UPDATE_EFFECTIVE_DATE",
  UPDATE_DEPRECIATION: "UPDATE_DEPRECIATION",
  UPDATE_MANUAL_FMV: "UPDATE_MANUAL_FMV",
  UPDATE_IS_ON_MANUAL_FMV: "UPDATE_IS_ON_MANUAL_FMV",
  UPDATE_DEAL_ID: "UPDATE_DEAL_ID",
  UPDATE_DEAL_DATA: "UPDATE_DEAL_DATA",
  UPDATE_PERSON_NAME: "UPDATE_PERSON_NAME",
  UPDATE_PERSON_EMAILS: "UPDATE_PERSON_EMAILS",
  UPDATE_PERSON_PHONES: "UPDATE_PERSON_PHONES",
  UPDATE_GRAPH_BANK_PARTNERS: "UPDATE_GRAPH_BANK_PARTNERS",
  UPDATE_QUOTES: "UPDATE_QUOTES",
  UPDATE_SELECTED_QUOTES: "UPDATE_SELECTED_QUOTES",
  RESET_STATES: "RESET_STATES",
  UPDATE_RESHUFFLE: "UPDATE_RESHUFFLE",
  UPDATE_NUMBER_OF_SEATS: "UPDATE_NUMBER_OF_SEATS"
}

export default ACTION_TYPES;